import Lock from './src/lock-combined';
export default Lock;